<template>
  <div>
    <filter-slot
      :filter="filters"
      :filterPrincipal="filterPrincipal"
      :paginate="paginate"
      @reload="$refs['ref-email-group-table'].refresh()"
    >
      <template #table>
        <b-table
          ref="ref-email-group-table"
          :per-page="paginate.perPage"
          :current-page="paginate.currentPage"
          sticky-header="50vh"
          small
          class="position-relative font-small-3"
          table-class="text-nowrap"
          :busy.sync="isBusy"
          :fields="fields"
          :items="myProvider"
          primary-key="id"
          :empty-text="$t('NO MATCHING RECORDS FOUND')"
        >
          <template #table-busy>
            <b-skeleton-table
              :headers="fields"
              :rows="paginate.perPage"
              :columns="fields.length"
              :table-props="{ bordered: true, striped: true }"
            />
          </template>

          <template #cell(name)="row">
            <span>{{ row.value }}</span>
          </template>
          <template #cell(users)="row">
            <b-row class="px-1" align-v="center" align-h="center">
              <template v-for="(user, i) in JSON.parse(row.value)">
                <b-col cols="auto" :key="i">
                  <b-badge
                    v-if="user.username"
                    variant="light-primary"
                    class="mr-1"
                    v-b-tooltip.hover.topright
                    data-html="true"
                    placement="top-right"
                  >
                    {{ user.username }}
                    <feather-icon
                      v-if="getTrashValue(row.item.id)"
                      icon="Trash2Icon"
                      size="15"
                      class="cursor-pointer text-danger"
                      @click="
                        removeUserFromRecipientGroup(row.item.id, user.user_id)
                      "
                    />
                  </b-badge>
                </b-col>
              </template>
              <feather-icon
                icon="PlusIcon"
                class="cursor-pointer text-success"
                :id="`link-button${row.item.id}`"
                href="#"
                tabindex="0"
                size="15"
              />
            </b-row>
            <b-popover
              boundary="viewport"
              placement="topright"
              :target="`link-button${row.item.id}`"
              :title="$t('Search users')"
              variant="primary"
              triggers="focus"
            >
              <SearchUsers
                :text="userText"
                @userSelected="handleUserSelected($event, row.item)"
              />
            </b-popover>
          </template>

          <template #cell(status)="data">
            <b-form-checkbox
              v-model="data.value"
              :switch="true"
              :size="'sm'"
              :variant="'primary'"
              :value="1"
              :unchecked-value="0"
              @input="changeStatus(data.item, data.value)"
            />
          </template>

          <template #cell(actions)="row">
            <feather-icon
              v-if="!getTrashValue(row.item.id)"
              v-b-tooltip.hover
              :title="$t('Enable Delete')"
              class="cursor-pointer text-danger"
              size="15"
              @click="toggleDelete(row.item.id)"
              icon="EditIcon"
            ></feather-icon>
            <feather-icon
              v-else
              v-b-tooltip.hover
              :title="$t('Disable Delete')"
              class="cursor-pointer text-success"
              size="15"
              @click="toggleDelete(row.item.id)"
              icon="EditIcon"
            />
          </template>
        </b-table>
      </template>
    </filter-slot>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import EmailRecipientGroupsService from "@/views/settings/views/general/components/email/services/email.recipient-groups.service.js";
import FilterSlot from "@/views/commons/filter-slot/FilterSlot.vue";
import Fields from "@/views/settings/views/general/components/email/fields/email.recipients-group.fields.js";
import SearchUsers from "@/views/commons/utilities/SearchUsers.vue";

export default {
  name: "EmailRecipientsGroups",
  components: {
    FilterSlot,
    SearchUsers,
  },
  data() {
    return {
      userText: "",
      userSelected: {},
      fields: Fields,
      filters: [],
      isBusy: false,
      searchQuery: "",
      filterPrincipal: {
        type: "input",
        inputType: "text",
        placeholder: "Search...",
        model: "",
      },
      paginate: {
        from: 0,
        to: 0,
        of: 0,
        perPage: 10,
        currentPage: 1,
      },
      buttonRowState: [],
    };
  },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
    }),
  },
  methods: {
    getTrashValue(id) {
      return this.buttonRowState.find((item) => item.id === id).showTrash;
    },
    toggleDelete(id) {
      this.buttonRowState.find((item) => item.id === id).showTrash =
        !this.buttonRowState.find((item) => item.id === id).showTrash;
    },
    async handleUserSelected($event, row) {
      let currentUsers = JSON.parse(row.users);
      let incomingUserId = $event.id;

      let userExists = currentUsers.find(
        (user) => user.user_id === incomingUserId
      );

      if (userExists) {
        this.userText = null;
        this.showToastWarning("User already exists in this group");
        return;
      }

      this.userSelected = $event;
      this.userSelected.recipient_group_id = row.id;
      this.userText = null;
      await this.addUserIntoRecipientGroup();
    },

    async addUserIntoRecipientGroup() {
      try {
        this.addPreloader();
        let params = {
          user_id: this.userSelected.id,
          recipient_group_id: this.userSelected.recipient_group_id,
        };
        const { data } =
          await EmailRecipientGroupsService.addUserIntoRecipientGroup(params);
        this.showToastSuccess("User added successfully");
        this.refreshTable();
      } catch (error) {
        console.log(error);
      } finally {
        this.removePreloader();
      }
    },

    async myProvider(ctx) {
      try {
        this.addPreloader();
        let params = {
          page: ctx.currentPage,
          perpage: ctx.perPage,
          search: this.filterPrincipal.model,
          orderby: 1,
          order: "desc",
        };
        const { data } = await EmailRecipientGroupsService.listRecipientsGroups(
          params
        );
        // fill buttonRowState
        data.data.forEach((element) => {
          this.buttonRowState.push({
            showTrash: false,
            id: element.id,
          });
        });

        this.paginate.from = data.from;
        this.paginate.to = data.to;
        this.paginate.of = data.total;
        this.paginate.perPage = data.per_page;
        this.paginate.currentPage = data.current_page;
        return data.data || [];
      } catch (error) {
        console.log(error);
        return [];
      } finally {
        this.removePreloader();
      }
    },
    refreshTable() {
      this.$refs["ref-email-group-table"].refresh();
    },
    async changeStatus(data, value) {
      try {
        this.addPreloader();
        let params = {
          id: data.id,
          status: value,
        };
        console.log(params);
        await EmailRecipientGroupsService.enableOrDisableRecipientGroup(params);
      } catch (error) {
        console.log(error);
      } finally {
        await this.removePreloader();
      }
    },

    async removeUserFromRecipientGroup(recipientGroupId, userId) {
      try {
        this.addPreloader();
        let params = {
          recipient_group_id: recipientGroupId,
          user_id: userId,
        };
        await EmailRecipientGroupsService.removeUserFromRecipientGroup(params);
        this.showToastSuccess("User removed successfully");
        this.refreshTable();
      } catch (error) {
        console.log(error);
      } finally {
        this.removePreloader();
      }
    },
  },
};
</script>